import { useRef, useState, useEffect } from 'react'
import { ReactSVG } from 'react-svg'

import cn from 'classnames'

import ActiveTabBackground from './images/tab.svg'
import ActiveTabBackgroundBig from './images/tab-big.svg'
import ActiveTabBackgroundMobile from './images/tab-mobile.svg'

import styles from './styles.module.scss'
import { ITabsProps } from './tabs.props'
import { useTranslation } from 'utils/use-translation'

export function Tabs({ activeTab, onTabChange, tabs, isZones, loansCount, className, tabClassName }: ITabsProps) {
  const { t } = useTranslation()
  const [activePosition, setActivePosition] = useState({ left: -1 })

  const hoverEl = useRef()
  const [screenWidth, setScreenWidth] = useState<number>(0)

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setScreenWidth(window.innerWidth)
    }
  })

  const activateTab = (event, tabName) => {
    if (!onTabChange) {
      return
    }
    onTabChange(tabName)
    const link = event.target.closest('div')
    const linkRect = link.getBoundingClientRect()
    const containerRect = link.parentElement.getBoundingClientRect()
    if (screenWidth < 765) {
      setActivePosition({ left: linkRect.left - containerRect.left })
    } else {
      setActivePosition({ left: linkRect.left - containerRect.left - 1 })
    }
  }

  useEffect(() => {
    const activeLink = document.querySelector(`.${styles.tab}.${styles.activeTab}`)

    if (activeLink) {
      const linkRect = activeLink.getBoundingClientRect()
      const containerRect = activeLink.parentElement.getBoundingClientRect()

      if (screenWidth < 765) {
        setActivePosition({ left: linkRect.left - containerRect.left })
      } else {
        setActivePosition({ left: linkRect.left - containerRect.left - 1 })
      }
    }
  }, [activeTab, screenWidth])

  return (
    tabs &&
    tabs.length && (
      <>
        <div className={cn(styles.tabs, className)}>
          {tabs.map((tab) => (
            <div
              key={tab.name}
              className={cn(
                styles.tab,
                { [styles.activeTab]: activeTab === tab.name },
                { [styles.tab_nozone]: !isZones },
                { [styles.tab_green]: isZones && tab.name?.toLowerCase() === 'green' },
                { [styles.tab_orange]: isZones && tab.name?.toLowerCase() === 'orange' },
                { [styles.tab_red]: isZones && tab.name?.toLowerCase() === 'red' },
                tabClassName,
              )}
              style={{ width: `${100 / tabs?.length}%` }}
              onClick={(e) => activateTab(e, tab.name)}
            >
              {tab.icon && <ReactSVG src={tab.icon} className={styles.icon} />}
              {!isZones && <p className={styles.tabText}>{tab.name}</p>}
              {isZones && (
                <>
                  <p className={cn(styles.tabText, styles.tabText_desktop)}>
                    <span className={styles[tab.name?.toLowerCase()]}>{t(tab.name.toLowerCase())}</span> {t('zone_info')}</p>

                  <p className={cn(styles.tabText, styles.tabText_mobile)}>
                    <span className={cn(styles[tab.name?.toLowerCase()], { [styles.active]: activeTab === tab.name })}>
                      {tab.count}/{loansCount}
                    </span>
                  </p>
                </>
              )}
              {screenWidth < 765 && isZones ? (
                <></>
              ) : tab.count ? (
                <small className={styles.tabCount}>({tab.count})</small>
              ) : (
                <></>
              )}
            </div>
          ))}
          <img
            ref={hoverEl}
            src={
              window.innerWidth > 765
                ? tabs.length === 3
                  ? ActiveTabBackground
                  : ActiveTabBackgroundBig
                : ActiveTabBackgroundMobile
            }
            className={cn(styles.activeBackground, { [styles.activeBackground_zone]: isZones })}
            style={{
              transform: `translateX(${activePosition.left}px)`,
              width:
                tabs.length === 3
                  ? screenWidth > 765
                    ? 'calc(33.333% - 4px)'
                    : 'calc(33.333%)'
                  : screenWidth > 765
                  ? 'calc(50% + 4px)'
                  : 'calc(50%)',
            }}
          />
        </div>
      </>
    )
  )
}
